import { wizardInfo } from './wizardInfo';

const formInfo = {
  project_name: '',
  comments: '',
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
};

export const initialState = {
  wizardInfo,
  formInfo,
};



// WEBPACK FOOTER //
// ./src/store/reducers/OnboardingRedesign/initialState.js